import { render, staticRenderFns } from "./ValueTreeFieldType4.vue?vue&type=template&id=28c24396&scoped=true"
import script from "./ValueTreeFieldType4.vue?vue&type=script&lang=js"
export * from "./ValueTreeFieldType4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c24396",
  null
  
)

export default component.exports